import {
  SilverContainerBaseProps,
  SilverContainerChildInfo,
} from '@decisions/server/Silverdark/Designers/Forms/Containers';

export const isContainer = (component: SilverContainerChildInfo) =>
  !!(component.child as SilverContainerBaseProps)?.clientChildrenInfo;

export function setTypeName<T>(object: { $type?: string; __type?: string }, recursive = true): T {
  if (object && !object.__type && object.$type) {
    const fullQulifiedTypeName = object.$type.split(',');
    const fulltypeName = fullQulifiedTypeName[0];
    const typeName = fulltypeName.split('.');
    let name = typeName[typeName.length - 1];
    typeName.pop();
    name = `${name}:#${typeName.join('.')}`;
    object.__type = name;
    delete object.$type;
  }
  if (recursive && isPlainObject(object)) {
    for (let key in object) {
      if (object.hasOwnProperty(key)) {
        const o = (object as any)[key];
        if (isPlainObject(o)) {
          setTypeName(o, recursive);
        } else if (Array.isArray(o)) {
          (o as Array<any>).forEach(s => setTypeName(s, recursive));
        }
      }
    }
  }
  return object as T;
}

function isPlainObject(obj: any) {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    (!obj.constructor || obj.constructor === Object) &&
    Object.prototype.toString.call(obj) === '[object Object]'
  );
}
